import { AxiosApi } from "api";
import { ApiResponse } from "interface/response";
import { BuyerStatistic, VesselStatistic } from "interface/statistic";
import { useInfoStore } from "store/error";

export async function getBuyerStatisticApi({ buyerId, year }: { buyerId: number; year: number }) {
    const apiUri = "Statistic/Buyer";
    try {
        const buyer = await AxiosApi.get<ApiResponse<BuyerStatistic>>(apiUri, {
            params: { buyerId, year },
        });
        return buyer.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getVesselStatisticApi({ vesselId, vesselRegistrationNumber, catchYear }: { vesselId: string; vesselRegistrationNumber: string; catchYear: number }) {
    const apiUri = "Statistic/Vessel";

    //console.log('getVesselStatisticApi', vesselId, vesselRegistrationNumber, catchYear);

    try {
        const vessel = await AxiosApi.get<ApiResponse<VesselStatistic>>(apiUri, {
            params: { vesselId, vesselRegistrationNumber, catchYear },
        });
        return vessel.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}
